module.exports = __webpack_public_path__ + "poi-group.png";